module.exports = __webpack_public_path__ + "static/img/complianceWizardBg4.d1c2a25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/complianceWizardBg4.jpg
// module id = sQLh
// module chunks = 0